import type { SVGProps } from 'react';

/** The board's lotus, drawn as gold line work. Decorative only. */
export function Lotus({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 32"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      <path d="M24 4C29 10 29 20 24 26 19 20 19 10 24 4Z" />
      <path d="M24 26C16 24 12 16 13 9 18 12 22 18 24 26ZM24 26C32 24 36 16 35 9 30 12 26 18 24 26Z" />
      <path d="M24 26C14 27 6 22 3 16 10 15 18 19 24 26ZM24 26C34 27 42 22 45 16 38 15 30 19 24 26Z" />
      <path d="M13 29.5C19 31.5 29 31.5 35 29.5" />
    </svg>
  );
}

/** Gold rule - lotus - gold rule, as on the board's logo card. */
export function LotusDivider({
  className = '',
  tone = 'gold',
  align = 'center',
}: {
  className?: string;
  tone?: 'gold' | 'maroon';
  align?: 'center' | 'start';
}) {
  const color = tone === 'gold' ? 'text-gold' : 'text-maroon';
  const justify = align === 'center' ? 'justify-center' : 'justify-start';
  return (
    <div className={`flex items-center gap-4 ${justify} ${color} ${className}`} aria-hidden="true">
      <span className="h-px w-14 bg-current sm:w-20" />
      <Lotus className="h-5 w-8" />
      <span className="h-px w-14 bg-current sm:w-20" />
    </div>
  );
}
